import React from 'react'

import { Layout } from 'components'

import { CreateUser } from 'modules/Users/containers'

const CreateUserPage = () => (
  <Layout>
    <CreateUser />
  </Layout>
)

export default CreateUserPage
